const ArubaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110786)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M20.0004 39.9995C26.0622 39.9995 31.4937 37.3023 35.1614 33.043H4.83936C8.50709 37.3023 13.9386 39.9995 20.0004 39.9995Z"
        fill="#338AF3"
      />
      <path
        d="M40 20C40 8.95437 31.0456 0 20 0C8.95437 0 0 8.95437 0 20C0 21.8052 0.240625 23.5538 0.688984 25.2174H39.3111C39.7594 23.5538 40 21.8052 40 20Z"
        fill="#338AF3"
      />
      <path
        d="M1.58984 27.8271C1.97539 28.7331 2.42609 29.6043 2.93555 30.4358H37.0646C37.5741 29.6043 38.0248 28.733 38.4105 27.8271H1.58984Z"
        fill="#338AF3"
      />
      <path
        d="M9.16482 12.6143L5.25732 10.8898L9.16482 9.16523L10.8893 5.25781L12.6137 9.16523L16.5212 10.8898L12.6137 12.6143L10.8893 16.5217L9.16482 12.6143Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.8894 7.41113L11.9543 9.82434L14.3676 10.8894L11.9543 11.9544L10.8894 14.3676L9.82434 11.9544L7.41113 10.8894L9.82434 9.82434L10.8894 7.41113Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110786">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ArubaSvg;
